import { countTokens } from '@/components/ui/custom/dataInput/TokenInput';
import { BLANK_PATTERN } from '@/utils/questions/parseFillInTheBlank';

export const countBlanks = (value: string) => countTokens(value, BLANK_PATTERN);
